import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContextMenuModule } from 'ngx-contextmenu';
import * as fromModules from '../modules';
import * as fromComponents from './components';
import * as fromDialogs from './dialogs';
import * as fromDirectives from './directives';
import { ServicesModule } from '../services/services.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ...fromComponents.components,
    ...fromDialogs.dialogs,
    ...fromDirectives.pipes,
    ...fromDirectives.directives
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ContextMenuModule,
    ...fromModules.modules,
    ServicesModule
  ],
  exports: [...fromComponents.components],
  providers: [],
  entryComponents: [...fromDialogs.dialogs]
})
export class CommonComponentsModule {}
